"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ChevronUp = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronUp"));
var _ChevronDown = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronDown"));
var _NavigationItemIcon = _interopRequireDefault(require("./NavigationItemIcon"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ExpandNavigationItemIcon = function ExpandNavigationItemIcon(_ref) {
  var isExpanded = _ref.isExpanded;
  return /*#__PURE__*/_react["default"].createElement(_NavigationItemIcon["default"], {
    icon: isExpanded ? _ChevronUp["default"] : _ChevronDown["default"],
    small: true
  });
};
ExpandNavigationItemIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  isExpanded: _propTypes["default"].bool
} : {};
var _default = exports["default"] = ExpandNavigationItemIcon;